import * as React from "react";
const AnsweredDurationIcon = (props) => (
  <svg
    width={45}
    height={45}
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.000488281} width={45} height={45} rx={6} fill="#8b58f1" />
    <g clipPath="url(#clip0_43824_67472)">
      <path
        d="M33.0005 27.6567V31.782C33.0006 32.0774 32.8887 32.3618 32.6873 32.5779C32.486 32.794 32.2101 32.9257 31.9155 32.9463C31.4057 32.9813 30.9892 33 30.6672 33C20.3573 33 12.0005 24.6432 12.0005 14.3333C12.0005 14.0113 12.018 13.5948 12.0542 13.085C12.0748 12.7904 12.2065 12.5145 12.4226 12.3131C12.6387 12.1118 12.9231 11.9999 13.2185 12H17.3438C17.4885 11.9999 17.6281 12.0535 17.7355 12.1505C17.8429 12.2475 17.9104 12.381 17.9248 12.525C17.9517 12.7933 17.9762 13.0068 17.9995 13.169C18.2313 14.7871 18.7065 16.3608 19.4088 17.8368C19.5197 18.0702 19.4473 18.349 19.2373 18.4983L16.7197 20.2973C18.259 23.8842 21.1175 26.7426 24.7043 28.282L26.501 25.769C26.5744 25.6663 26.6816 25.5927 26.8037 25.5609C26.9259 25.5292 27.0553 25.5413 27.1695 25.5952C28.6453 26.2962 30.2187 26.7701 31.8362 27.001C31.9983 27.0243 32.2118 27.05 32.4778 27.0757C32.6216 27.0904 32.7548 27.158 32.8516 27.2653C32.9483 27.3727 33.0018 27.5121 33.0017 27.6567H33.0005Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 21C29.0609 21 30.0783 20.5786 30.8284 19.8284C31.5786 19.0783 32 18.0609 32 17C32 15.9391 31.5786 14.9217 30.8284 14.1716C30.0783 13.4214 29.0609 13 28 13C26.9391 13 25.9217 13.4214 25.1716 14.1716C24.4214 14.9217 24 15.9391 24 17C24 18.0609 24.4214 19.0783 25.1716 19.8284C25.9217 20.5786 26.9391 21 28 21ZM30.5 17H28.5V14.5H27.5V18H30.5V17Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 17C23 19.7615 25.2385 22 28 22C30.7615 22 33 19.7615 33 17C33 14.2385 30.7615 12 28 12C25.2385 12 23 14.2385 23 17ZM30.8284 19.8284C30.0783 20.5786 29.0609 21 28 21C26.9391 21 25.9217 20.5786 25.1716 19.8284C24.4214 19.0783 24 18.0609 24 17C24 15.9391 24.4214 14.9217 25.1716 14.1716C25.9217 13.4214 26.9391 13 28 13C29.0609 13 30.0783 13.4214 30.8284 14.1716C31.5786 14.9217 32 15.9391 32 17C32 18.0609 31.5786 19.0783 30.8284 19.8284Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_43824_67472">
        <rect
          width={28}
          height={28}
          fill="white"
          transform="translate(8.50049 8.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default AnsweredDurationIcon;
